import { render, staticRenderFns } from "./StudentCenter.vue?vue&type=template&id=089e0a1e"
import script from "./StudentCenter.vue?vue&type=script&lang=js"
export * from "./StudentCenter.vue?vue&type=script&lang=js"
import style0 from "./StudentCenter.vue?vue&type=style&index=0&id=089e0a1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports